import { faComments } from '@fortawesome/free-regular-svg-icons'
import { faBookmark, faShare } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import { Link } from 'react-router-dom'
import Style from './ForumCourseList.module.css'
const ForumCourseList = ({item}) => {
    return (
        <Link to={{pathname:`/forum/${item.id}`, state: item}}>
            <div className={Style.CourseFourmHolder}>
                <h3><FontAwesomeIcon icon={faBookmark}/>   {item.name} </h3>
                <div className={Style.InfoHolder}>
                    <p>
                        <FontAwesomeIcon icon={faShare}/>
                        {item.total_answer}
                    </p>
                    <p>
                        <FontAwesomeIcon icon={faComments}/>
                        {item.total_question}
                    </p>
                </div>
            </div>
        </Link>
    )
}

export default ForumCourseList
